module.exports = __webpack_public_path__ + "assets/media/day8.92fabb1a.mp3";